import { FC, useMemo } from 'react';
import { FormatLinkedText } from 'brg-longread';
import ResizedImageEnhanced from '../../../../components/ResizedImageEnhanced';
import {
  LongreadBlockWrapper,
  TwoPicturesPrintWrap,
  TwoPicturesList,
  TwoPicturesItem,
  CaptionBlockWrapper,
  TextBlock,
  ImageTextShadow,
  ImageTextTwoPicturesPrint,
} from '../../styles/LongreadBlockRenderer.styles';
import { invertColor } from '../../utils/colorUtils';

interface TwoPicturesBlockProps {
  block: any;
  backgroundColor?: string;
  stackOnMobile?: boolean;
}

export const TwoPicturesBlock: FC<TwoPicturesBlockProps> = ({ block, backgroundColor, stackOnMobile = false }) => {
  const twoPicturesAttachments = block.attachments || [];
  const hasTwoPictures = twoPicturesAttachments.length >= 2;

  const defaultTextColor = useMemo(() => {
    if (!backgroundColor) return '#151514';
    return invertColor(backgroundColor, '#FEFEFE', '#151514');
  }, [backgroundColor]);

  const TwoPicturesImageItem: FC<{ attachment: any; index: number }> = ({ attachment, index }) => {
    const imageFiles = attachment.files || [];
    const imageText = attachment.text || '';
    const textPosition = attachment.textPosition || 'bottom';
    
    const imageRatio = useMemo(() => {
      if (imageFiles.length > 0 && imageFiles[0].width && imageFiles[0].height) {
        return imageFiles[0].width / imageFiles[0].height;
      }
      return null;
    }, [imageFiles]);
    
    const isHorizontal = imageRatio !== null && imageRatio > 1;
    
    return (
      <TwoPicturesItem key={attachment.postAttachmentId || index} isHorizontal={isHorizontal} stackOnMobile={stackOnMobile} ratio={imageRatio || 1}>
        {imageFiles.length > 0 && (
          <>
            <ResizedImageEnhanced files={imageFiles} />
            {imageText && (
              <>
                <ImageTextShadow position={textPosition} />
                <ImageTextTwoPicturesPrint position={textPosition}>
                  <FormatLinkedText text={imageText} />
                </ImageTextTwoPicturesPrint>
              </>
            )}
          </>
        )}
      </TwoPicturesItem>
    );
  };

  return (
    <LongreadBlockWrapper>
      <TwoPicturesPrintWrap style={{ backgroundColor: backgroundColor }} withoutCaption={!block.caption}>
        {hasTwoPictures ? (
          <TwoPicturesList stackOnMobile={stackOnMobile}>
            {twoPicturesAttachments.slice(0, 2).map((attachment: any, index: number) => (
              <TwoPicturesImageItem key={attachment.postAttachmentId || index} attachment={attachment} index={index} />
            ))}
          </TwoPicturesList>
        ) : (
          <TextBlock textColor={defaultTextColor}>
            {block.text && <FormatLinkedText text={block.text} />}
          </TextBlock>
        )}
        {block.caption && (
          <CaptionBlockWrapper textColor={defaultTextColor}>
            <FormatLinkedText text={block.caption} />
          </CaptionBlockWrapper>
        )}
      </TwoPicturesPrintWrap>
    </LongreadBlockWrapper>
  );
};
import { FC, useMemo } from 'react';
import { FormatLinkedText } from 'brg-longread';
import ResizedImageEnhanced from '../../../../components/ResizedImageEnhanced';
import {
  LongreadBlockWrapper,
  TwoPicturesPrintWrap,
  TwoPicturesList,
  TwoPicturesItem,
  CaptionBlockWrapper,
  TextBlock,
  ImageTextShadow,
  ImageTextTwoPicturesPrint,
} from '../../styles/LongreadBlockRenderer.styles';
import { invertColor } from '../../utils/colorUtils';

interface TwoPicturesBlockProps {
  block: any;
  backgroundColor?: string;
  stackOnMobile?: boolean;
}

export const TwoPicturesBlock: FC<TwoPicturesBlockProps> = ({ block, backgroundColor, stackOnMobile = false }) => {
  const twoPicturesAttachments = block.attachments || [];
  const hasTwoPictures = twoPicturesAttachments.length >= 2;

  const defaultTextColor = useMemo(() => {
    if (!backgroundColor) return '#151514';
    return invertColor(backgroundColor, '#FEFEFE', '#151514');
  }, [backgroundColor]);

  const TwoPicturesImageItem: FC<{ attachment: any; index: number }> = ({ attachment, index }) => {
    const imageFiles = attachment.files || [];
    const imageText = attachment.text || '';
    const textPosition = attachment.textPosition || 'bottom';
    
    const imageRatio = useMemo(() => {
      if (imageFiles.length > 0 && imageFiles[0].width && imageFiles[0].height) {
        return imageFiles[0].width / imageFiles[0].height;
      }
      return null;
    }, [imageFiles]);
    
    const isHorizontal = imageRatio !== null && imageRatio > 1;
    
    return (
      <TwoPicturesItem key={attachment.postAttachmentId || index} isHorizontal={isHorizontal} stackOnMobile={stackOnMobile} ratio={imageRatio || 1}>
        {imageFiles.length > 0 && (
          <>
            <ResizedImageEnhanced files={imageFiles} />
            {imageText && (
              <>
                <ImageTextShadow position={textPosition} />
                <ImageTextTwoPicturesPrint position={textPosition}>
                  <FormatLinkedText text={imageText} />
                </ImageTextTwoPicturesPrint>
              </>
            )}
          </>
        )}
      </TwoPicturesItem>
    );
  };

  return (
    <LongreadBlockWrapper>
      <TwoPicturesPrintWrap style={{ backgroundColor: backgroundColor }} withoutCaption={!block.caption}>
        {hasTwoPictures ? (
          <TwoPicturesList stackOnMobile={stackOnMobile}>
            {twoPicturesAttachments.slice(0, 2).map((attachment: any, index: number) => (
              <TwoPicturesImageItem key={attachment.postAttachmentId || index} attachment={attachment} index={index} />
            ))}
          </TwoPicturesList>
        ) : (
          <TextBlock textColor={defaultTextColor}>
            {block.text && <FormatLinkedText text={block.text} />}
          </TextBlock>
        )}
        {block.caption && (
          <CaptionBlockWrapper textColor={defaultTextColor}>
            <FormatLinkedText text={block.caption} />
          </CaptionBlockWrapper>
        )}
      </TwoPicturesPrintWrap>
    </LongreadBlockWrapper>
  );
};
